import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { Site } from '@debbie/common/dist';
import { VoucherCategory, VoucherTypeIds, } from '@debbie/common/dist/economy/vouchers';
import VoucherTypeSelector from '../VoucherTypeSelector';
import VoucherCreator from './VoucherCreator';
const CreateVoucher = (props) => {
    const lang = useSelector((s) => s.lang);
    const site = useSelector((s) => s.site);
    const [voucherType, setVoucherType] = useState(null);
    return voucherType ? (React.createElement(VoucherCreator, { header: voucherType.voucherTypeId === VoucherTypeIds.OVERPAYMENT
            ? lang.economy.voucherCreationCreditorDeposit
            : lang.economyVoucherTypeLabels[voucherType.voucherTypeId], voucherType: voucherType, creditorId: props.creditorId, onBack: () => {
            setVoucherType(null);
        }, onCreate: () => {
            setVoucherType(null);
            props.onCreate();
        }, defaultImposedByCreditor: props.defaultImposedByCreditor, caseId: props.caseId, caseVouchers: props.caseVouchers, singleCase: props.singleCase })) : (React.createElement(VoucherTypeSelector, { onSelect: (type) => {
            setVoucherType(type);
        }, typeMap: Object.assign({ [VoucherCategory.TRANSACTION]: (voucherTypes) => {
                return voucherTypes
                    .filter((vt) => vt.voucherTypeId !== VoucherTypeIds.OVERPAYMENT &&
                    ((site === Site.Client &&
                        vt.voucherTypeId === VoucherTypeIds.DEPOSIT) ||
                        site !== Site.Client))
                    .map((vt) => vt.voucherTypeId === VoucherTypeIds.DEPOSIT
                    ? {
                        label: lang.economy.voucherCreationCreditorDeposit,
                        type: vt,
                    }
                    : {
                        label: lang.economyVoucherTypeLabels[vt.voucherTypeId],
                        type: vt,
                    });
            } }, props.typeMap), voucherTypeFilter: props.voucherTypeFilter, categoryFilter: Array.isArray(props.categoryFilter)
            ? props.categoryFilter
            : site === Site.Client
                ? [VoucherCategory.TRANSACTION]
                : [
                    VoucherCategory.TRANSACTION,
                    VoucherCategory.COST,
                    VoucherCategory.COURTCOST,
                    VoucherCategory.INTEREST,
                    VoucherCategory.PRINCIPAL,
                ] }));
};
export default CreateVoucher;
//# sourceMappingURL=CreateVoucher.js.map